import React, {Component} from 'react';
import {ChannelLogo} from "../channels/ChannelLogo";
import {CHANNEL_INFO_BY_CHANNEL} from "../channels/channels";


export class MultiSelectChannelNoConnectionItem extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        window.open('/agency/conections', '_blank');
    }

    _itemText() {
        return `Conectar a ${CHANNEL_INFO_BY_CHANNEL[this.props.channel]?.Spanish || this.props.channel} para ver cuentas ↗️`;
    }

    render() {
        return (
            <li key={`li-${this.props.itemId}`} onClick={(event) => {this.handleClick()}}>
                <label className={`multi-select-item link-item -${this.props.channel.toLowerCase()}`}>
                    <div className="multi-select-item-name"><span className="logo"><ChannelLogo useOld={false}
                                                                         marginLeft={0}
                                                                         padding={0}
                                                                         width={20}
                                                                         height={20}
                                                                         hspace={0} vspace={0}
                                                                         channel={this.props.channel}/></span>{this._itemText()}</div>
                </label>
            </li>
        )
    }
}


export class MultiSelectChannelNewSeparatelyConnectionItem extends MultiSelectChannelNoConnectionItem {
    _itemText() {
        return `Conectar una nueva cuenta de ${CHANNEL_INFO_BY_CHANNEL[this.props.channel]?.Spanish || this.props.channel} ↗️`;
    }
}